<template>
  <div
    class="lt-section tw-relative tw-w-full tw-h-screen tw-box-content tw-overflow-hidden tw-bg-second-section tw-bg-no-repeat tw-bg-cover"
  >
    <img
      v-animate="{ value: 'fadeIn', delay: 50 }"
      class="tw-absolute z-10 tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-m-auto tw-overflow-visible tw-w-full"
      :src="`${imgPath}/animation-light-effect1.png`"
    />
    <!-- <div class="tw-absolute tw-top-0 tw-w-full tw-h-32 tw-bg-white"></div> -->
    <div class="tw-h-full tw-flex tw-flex-col tw-items-center">
      <div
        v-animate="{ value: 'fadeInUp', delay: 100 }"
        class="tw-flex tw-flex-col tw-items-center tw-justify-end xl:tw-h-1/4 lg:tw-h-3/10 z-20 tw-m-2.5"
      >
        <span
          class="tw-font-sans tw-font-medium tw-text-grayish-blue tw-text-3xl"
          >PLAINS FILLED WITH HIDDEN TRUTHS</span
        >
        <span
          class="tw-font-caslon tw-text-white tw-mt-7 xl:tw-text-8.4xl lg:tw-text-8xl"
          >ZISK PLAINS</span
        >
      </div>
      <div
        class="tw-flex tw-flex-row tw-align-center tw-justify-center tw-z-10 lg:tw-px-20"
      >
        <div
          v-animate="{ value: 'fadeInUp', delay: 400 }"
          class="2xl:tw-m-1 tw-cursor-pointer lg:tw-m-3"
          @mouseover="navHover(0)"
          @mouseleave="navHover(0)"
          @click="moveToSlide(0)"
        >
          <img
            :src="`${imgPath}${linkCard[0].imgUrlHover}`"
            v-if="linkCard[0].isHover"
          />
          <img
            :src="`${imgPath}${linkCard[0].imgUrl}`"
            v-if="!linkCard[0].isHover"
          />
        </div>
        <div
          v-animate="{ value: 'fadeInUp', delay: 500 }"
          class="2xl:tw-m-1 tw-cursor-pointer lg:tw-m-3"
          @mouseover="navHover(1)"
          @mouseleave="navHover(1)"
          @click="moveToSlide(1)"
        >
          <img
            :src="`${imgPath}${linkCard[1].imgUrlHover}`"
            v-if="linkCard[1].isHover"
          />
          <img
            :src="`${imgPath}${linkCard[1].imgUrl}`"
            v-if="!linkCard[1].isHover"
          />
        </div>
        <div
          v-animate="{ value: 'fadeInUp', delay: 600 }"
          class="2xl:tw-m-1 tw-cursor-pointer lg:tw-m-3"
          @mouseover="navHover(2)"
          @mouseleave="navHover(2)"
          @click="moveToSlide(2)"
        >
          <img
            :src="`${imgPath}${linkCard[2].imgUrlHover}`"
            v-if="linkCard[2].isHover"
          />
          <img
            :src="`${imgPath}${linkCard[2].imgUrl}`"
            v-if="!linkCard[2].isHover"
          />
        </div>
        <div
          v-animate="{ value: 'fadeInUp', delay: 700 }"
          class="2xl:tw-m-1 tw-cursor-pointer lg:tw-m-3"
          @mouseover="navHover(3)"
          @mouseleave="navHover(3)"
          @click="moveToSlide(3)"
        >
          <img
            :src="`${imgPath}${linkCard[3].imgUrlHover}`"
            v-if="linkCard[3].isHover"
          />
          <img
            :src="`${imgPath}${linkCard[3].imgUrl}`"
            v-if="!linkCard[3].isHover"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "second-section",
  props: {
    moveToSlide: { type: Function }
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      linkCard: [
        {
          id: "a",
          imgUrl: "/scenario.png",
          imgUrlHover: "/scenario_hover.png",
          isHover: false
        },
        {
          id: "b",
          imgUrl: "/map.png",
          imgUrlHover: "/map_hover.png",
          isHover: false
        },
        {
          id: "c",
          imgUrl: "/monster.png",
          imgUrlHover: "/monster_hover.png",
          isHover: false
        },
        {
          id: "d",
          imgUrl: "/npc.png",
          imgUrlHover: "/npc_hover.png",
          isHover: false
        }
      ]
    };
  },
  methods: {
    handleMove: function(index) {
      this.moveToSlide(index);
    },
    navHover: function(index) {
      this.linkCard[index].isHover = !this.linkCard[index].isHover;
    }
  }
};
</script>
